import PropTypes from 'prop-types'
import groupBy from 'lodash/groupBy'
import MenuItem from '@material-ui/core/MenuItem'
import React, { useState, useEffect } from 'react'
import MatchPlayItem from '@components/match-play-item'
import MatchPlayFullCoverageLink from '@components/match-play-full-coverage-link'
import Container from '@material-ui/core/Container'
import MatchPlayStatusBar from '@components/match-play-status-bar'
import useStyles, { SelectRound } from './match-play-leaderboard.styles'

const MatchPlayLeaderboard = (props) => {
  const {
    currentRound,
    updatedAt,
    startDate,
    endDate,
    matchPlayLeaderboard,
    fullCoverageUrl,
    extraLogo,
    leaderboardRef,
    isEmbedView,
  } = props

  const styles = useStyles({ isEmbedView })
  const [selectedRound, setSelectedRound] = useState(currentRound)
  const [groupedRoundScores, setGroupedRoundScores] = useState({})

  const rounds = [1, 2, 3, 4, 5]
  const roundsScores = []
  rounds.forEach(
    round => roundsScores.push(matchPlayLeaderboard.filter(match => match.round === round)),
  )

  const currentRoundScores = roundsScores[currentRound - 1]

  useEffect(() => {
    setSelectedRound(currentRound)
    setGroupedRoundScores(groupBy(currentRoundScores, 'matchId'))
  }, [matchPlayLeaderboard])


  const handleRoundChange = (e) => {
    setSelectedRound(e.target.value)
    setGroupedRoundScores(groupBy(roundsScores[e.target.value - 1], 'matchId'))
  }

  return (
    <div
      className={styles.root}
      ref={roundsScores[0].length === 0 ? leaderboardRef : null}
    >
      {!isEmbedView && (
        <MatchPlayStatusBar
          updatedAt={updatedAt}
          startDate={startDate}
          endDate={endDate}
        />
      )}
      {roundsScores[0].length > 0 && (
        <SelectRound
          variant="outlined"
          value={selectedRound}
          onChange={handleRoundChange}
          ref={leaderboardRef}
          select
          embedview={isEmbedView ? 1 : 0}
        >
          {roundsScores.map(val => val.length > 0 && (
            <MenuItem key={val[0].round} value={val[0].round}>
              {val[0].roundName}
            </MenuItem>
          ))}
        </SelectRound>
      )}
      <Container className={styles.container}>
        {Object.keys(groupedRoundScores)
          .map((key, i) => (
            <MatchPlayItem
              key={key}
              isEmbedView={isEmbedView}
              fullCoverageUrl={fullCoverageUrl}
              item={groupedRoundScores[key]}
              matchNumber={i + 1}
            />
          ))}
      </Container>
      {fullCoverageUrl
        && (
          <MatchPlayFullCoverageLink
            fullCoverageUrl={fullCoverageUrl}
            logo={extraLogo}
            isEmbedView={isEmbedView}
          />
        )
      }
    </div>
  )
}

MatchPlayLeaderboard.propTypes = {
  matchPlayLeaderboard: PropTypes.array,
  currentRound: PropTypes.number,
  fullCoverageUrl: PropTypes.string,
  isEmbedView: PropTypes.bool,
  extraLogo: PropTypes.shape({ url: PropTypes.string }),
  leaderboardRef: PropTypes.object,
  updatedAt: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
}

export default MatchPlayLeaderboard
